import angular from 'angular';

export class ServiceComponent {
  menu = [
    {
      title1: 'サービス',
      title2: '',
      state: 'strength',
      image: 'assets/images/IMG_0742-2.jpg',
      imageS: 'assets/images/IMG_0742-960.jpg'
    },
    {
      title1: '新型コロナ感染防止対策',
      title2: '',
      state: 'prevention',
      image: 'assets/images/sanitizer-kit1.jpg',
      imageS: 'assets/images/sanitizer-kit1-960.jpg'
    },
    {
      title1: '小旅行運行サービス',
      title2: '',
      state: 'short-trip',
      image: 'assets/images/Entrance.jpg',
      imageS: 'assets/images/Entrance-960.jpg'
    },
    {
      title1: '安全への',
      title2: '取組み',
      state: 'safety',
      image: 'assets/images/IMG_1174_1.jpg',
      imageS: 'assets/images/IMG_1174-960.jpg'
    },
    {
      title1: '地域への',
      title2: '貢献',
      state: 'contribution',
      image: 'assets/images/IMG_1659-1.jpg',
      imageS: 'assets/images/IMG_1659-960.jpg'
    }
  ]

  constructor() {
    this.currentTitle1 = 'サービス';
    this.currentTitle2 = '';
    this.currentImage = 'assets/images/IMG_0742-2.jpg';
    this.currentImageS = 'assets/images/IMG_0742-960.jpg';
  }
  getCurrentPage(currentTitle1, currentTitle2, currentImage, currentImageS) {
    this.currentTitle1 = currentTitle1;
    this.currentTitle2 = currentTitle2;
    this.currentImage = currentImage;
    this.currentImageS = currentImageS;
  }
}

export default angular.module('directives.service', [])
  .component('service', {
    template: require('./service.template.html'),
    controller: ServiceComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/service/service.component.js